import { createAction, props } from '@ngrx/store';
import { MyThreadInput } from '../../../shared/data/inputs/my-thread.input';
import { MessageThreadConnectionModel } from '../../../shared/data/models/message-thread-connection.model';
import { ThreadMessagesInput } from '../../../shared/data/inputs/thread-messages.input';
import { MessageConnectionModel } from '../../../shared/data/models/message-connection.model';
import { SendMessageInput } from '../inputs/send-message.input';
import { SendDmMessageSuccessInput } from '../inputs/send-dm-message-success.input';
import { SendDmMessageErrorInput } from '../inputs/send-dm-message-error.input';
import { MessageModel } from '../../../shared/data/models/message.model';

// toggle show threads.
export const toggleShowThreads = createAction('[DM] toggle show threads');

export const setShowThreadState = createAction(
  '[DM] set toggle show thread state',
  props<{ value: boolean }>()
);

/*
 * Load a list of dm threads
 * **/
export const loadMyDmThread = createAction(
  '[DM] load a list of dm threads',
  props<{ input: MyThreadInput }>()
);

export const loadMoreMyDmThread = createAction(
  '[DM] load More list of dm threads',
  props<{ input: MyThreadInput }>()
);

export const loadMyDmThreadSuccess = createAction(
  '[DM] load a list of dm threads Success',
  props<{ payload: MessageThreadConnectionModel }>()
);

export const loadMoreMyDmThreadSuccess = createAction(
  '[DM] load More list of dm threads Success',
  props<{ payload: MessageThreadConnectionModel }>()
);

export const loadMyDmThreadError = createAction(
  '[DM] load a list of dm threads Error',
  props<{ error: string }>()
);

/*
 * message operations - section
 **/
export const loadThreadMessages = createAction(
  '[DM] load thread message',
  props<{ input: ThreadMessagesInput; currentuserId?: string }>()
);

export const loadThreadMessagesSuccess = createAction(
  '[DM] load thread message success',
  props<{ payload: MessageConnectionModel; threadID: string }>()
);

export const loadThreadMessagesError = createAction(
  '[DM] load thread message error',
  props<{ error: string; threadID: string }>()
);

export const loadMoreThreadMessages = createAction(
  '[DM] load more thread messages',
  props<{ input: ThreadMessagesInput; currentuserId: string }>()
);

export const loadMoreThreadMessagesSuccess = createAction(
  '[DM] load more thread messages success',
  props<{ payload: MessageConnectionModel; threadID: string }>()
);

export const loadMoreThreadMessagesError = createAction(
  '[DM] load more thread messages error',
  props<{ error: string; threadID: string }>()
);

/**
 * set current currentThread: number;
 * */
export const setCurrentThreadID = createAction(
  '[DM] set current thread ID',
  props<{ threadID: string }>()
);

/**
 * send message section
 **/

export const sendDmMessage = createAction(
  '[DM] send Dm Message',
  props<{ payload: SendMessageInput }>()
);

export const sendDmMessageSuccess = createAction(
  '[DM] send Dm Message Success',
  props<{ payload: SendDmMessageSuccessInput }>()
);

export const sendNewMessageSuccess = createAction(
  '[DM] send new message success'
);

export const sendDmMessageError = createAction(
  '[DM] send Dm Message Error',
  props<{ payload: SendDmMessageErrorInput }>()
);

export const readDmMessage = createAction(
  '[DM] mark, read dm message',
  props<{ messageID: string; threadID: string }>()
);

export const readDmMessageSuccess = createAction(
  '[DM] mark, read dm message success',
  props<{ message: MessageModel; threadID: string; messageID: string }>()
);

export const readDmMessageError = createAction(
  '[DM] mark, read dm message error',
  props<{ messageID: string; threadID: string; error: string }>()
);

// clear messages

export const clearDmMessages = createAction('[DM] clear Dm Messages');
